import { render, staticRenderFns } from "./CallHandlingRules.vue?vue&type=template&id=6ea89844&"
import script from "./CallHandlingRules.vue?vue&type=script&lang=js&"
export * from "./CallHandlingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports